<template>
  <div class="container" id="container">
    <div id="dashboard" >
      <!-- Dashboard header -->
      <div class="dashboard__header mb-4 row no-gutters">

        <!-- Dashboard Title -->
        <div class="col-sm-12 col-md-12 dashboard__header--col" ref="topTitle">
          <div>
            <svg class="dashboard__header--icon h-100 display-inline-block" width="30" height="21" viewBox="0 0 30 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M29.1164 1.27581C27.2982 0.541767 25.4785 0.262496 23.6598 0.262496C17.8863 0.262045 12.1133 3.07506 6.33975 3.07506C4.8918 3.07506 3.44479 2.8982 1.99684 2.45605C1.83419 2.40643 1.67107 2.38298 1.5117 2.38298C0.704989 2.38298 0 2.98392 0 3.81813V18.1318C0 18.7016 0.3389 19.2416 0.883111 19.461C2.70136 20.1954 4.52103 20.4747 6.33975 20.4747C12.1133 20.4747 17.8868 17.6617 23.6603 17.6617C25.1082 17.6617 26.5552 17.8386 28.0031 18.2806C28.1658 18.3302 28.3289 18.3537 28.4883 18.3537C29.295 18.3537 30 17.7527 30 16.9186V2.60539C29.9996 2.03512 29.6606 1.49553 29.1164 1.27581ZM14.9997 14.6997C12.9284 14.6997 11.2498 12.7602 11.2498 10.3686C11.2498 7.97651 12.9289 6.03741 14.9997 6.03741C17.0707 6.03741 18.7497 7.97651 18.7497 10.3686C18.7497 12.7611 17.0701 14.6997 14.9997 14.6997Z" fill="#2B4D75"/>
              </svg>
            <h1 class="dashboard__header--title m-0 header">Plans and Coupon</h1>
          </div>
        </div>

      </div>

      <div class="row no-gutters" style="margin: 0 -10px;">

        <div class="col-lg-12 col-md-12 mb-4" style="padding: 0 10px;">
          <!-- Table Plans-->
          <div class="mb-2" style="display:table;width: 100%;">
            <h2 class="mb-2" style="display: table-cell; vertical-align: middle; width: 100%;">Plans</h2>
            <button class="btn btn--primary" style="white-space: nowrap;" @click.stop="addOrEditPlan(false)">New Plan</button>
          </div>
          <div id="products-table">
            <div class="products-table__search" >
              <s-input placeholder="Search for Plan" v-model="searchPlan"></s-input>
            </div>
            <s-card class="products-table__card border-top-0 p-0">
              <s-card-body class="product-table__table p-0">
                  <div class="product-table__table-container" @scroll="getScrollPosPlan">
                      <div class="div-shadow-left" v-if="!hideShadows && scrollIn && scrollIn !== 'left' && plansList && plansList.length"></div>
                      <!-- plansList && plansList.length &&  -->
                      <!-- style="width: 1731px;" -->
                      <table v-if="!loadingTablePlan" class="product-table__table--table"  id="myTablePlan">
                          <thead class="product-table__table--header border-0 p-0 mb-4">
                              <!-- ID -->
                              <td class="text-truncate product-table__table--header-id">
                                  <span>ID</span>
                              </td>
                              <!-- Name -->
                              <td class="text-truncate product-table__table--header-joined">
                                  <span>Name</span>
                              </td>
                              <!-- Interval -->
                              <td class="text-truncate product-table__table--header-joined">
                                  <span>Interval</span>
                              </td>
                              <!-- Price -->
                              <td class="text-truncate product-table__table--header-joined">
                                  <span>Price</span>
                              </td>
                              <!-- Max Adspend -->
                              <td class="text-truncate product-table__table--header-joined">
                                  <span>Max Adspend</span>
                              </td>
                              <!-- Actions -->
                              <td class="text-truncate product-table__table--header-domain">
                                  <span>Actions</span>
                              </td>
                          </thead>
                          <tbody class="product-table__table--body">
                              <tr class="w-100 display-table-cell" v-if="loadingTablePlan">
                                  <s-loader :type="'scalify'" class="my-3" style="left:calc(50% - 42px);position:relative;"></s-loader>
                              </tr>
                              <tr class="w-100 display-table-cell" v-if="!loadingTablePlan && (plansList == null || plansList.length == 0)">
                                  <p class="my-3 position-relative font-weight-sbold" style="left:40%;">No Results</p>
                              </tr>
                              <div v-if="plansList && plansList.length > 0" style="max-height: 700px; overflow-y: auto; display: grid;">
                                <tr  v-show="!loadingTablePlan" v-for="(plan, planIndex) in plansList" :key="planIndex" class="product-table__table--row w-100">
                                    <!-- ID -->
                                    <td  class="display-table-cell product-table__table--body-id">
                                      <p class="text-truncate">{{plan.id}}</p>
                                    </td>
                                    <!-- Name -->
                                    <td :tooltip-position="planIndex==0?'right':'top'" :tooltip="plan.name" class="display-table-cell product-table__table--body-joined">
                                      <p  class="text-truncate">{{plan.name}}</p>
                                    </td>
                                    <!-- Interval -->
                                    <td  class="display-table-cell product-table__table--body-joined">
                                      <p class="text-truncate">{{plan.interval?plan.interval:'Lifetime'}}</p>
                                    </td>
                                    <!-- Price -->
                                    <td class="display-table-cell product-table__table--body-joined">
                                      <p  class="text-truncate">{{plan.price}}</p>
                                    </td>
                                    <!-- Max Adspend -->
                                    <td  class="display-table-cell product-table__table--body-joined">
                                      <p class="text-truncate">{{plan.max_adspend}}</p>
                                    </td>
                                    <!-- Actions -->
                                    <td  class="display-table-cell product-table__table--body-domain">
                                      <button class="btn btn--white btn--sm" :class="loadingButonPlansActions?'disabled':''" @click.stop="addOrEditPlan(true, plan, planIndex)">Edit</button>
                                      <button class="btn btn--danger btn--sm ml-2" :class="loadingButonPlansActions?'disabled':''" @click.stop="deletePlanSelected(plan.id, planIndex)">Delete</button>
                                    </td>
                                </tr>
                              </div>

                          </tbody>
                      </table>
                      <table v-else-if="loadingTablePlan" class="product-table__table--table" style="width: 100%;" id="myTablePlan">
                        <tbody class="product-table__table--body">
                          <tr class="w-100 display-table-cell">
                            <s-loader :type="'scalify'" class="my-3" style="left:calc(50% - 42px);position:relative;"></s-loader>
                          </tr>
                        </tbody>
                      </table>
                      <div class="div-shadow-right" v-if="!hideShadows && scrollIn && scrollIn !== 'right' && ((plansList && plansList.length))"></div>
                  </div>
              </s-card-body>
              <s-card-body v-if="plansList && plansList.length && loadMorePlans && !loadingTablePlan" class="p-0 product-table__load-more text-center">
                <button v-if="!loadingLoadMorePlans" class="btn btn--white" @click="loadMoreListPlans()">Load More</button>
                <s-loader :type="'scalify'" v-else></s-loader>
            </s-card-body>
            </s-card>
          </div>
        </div>

        <div class="col-lg-12 col-md-12" style="padding: 0 10px;">
          <!-- Table Coupon-->
          <div class="mb-2" style="display:table;width: 100%;">
            <h2 class="mb-2" style="display: table-cell; vertical-align: middle; width: 100%;">Coupon</h2>
            <div style="white-space: nowrap;">
              <button class="btn btn--white" @click.stop="refundCoupon()">Refund Coupon</button>
              <button class="btn btn--primary ml-2" @click.stop="addNewCoupon()">New Coupon</button>
            </div>
          </div>
          <div id="products-table">
            <div class="products-table__search" >
              <s-input placeholder="Search for Coupon" v-model="searchCoupon"></s-input>
            </div>
            <s-card class="products-table__card border-top-0 p-0">
              <s-card-body class="product-table__table p-0">
                <div class="product-table__table-container" @scroll="getScrollPosCoupon">
                  <div class="div-shadow-left" v-if="!hideShadows && scrollIn && scrollIn !== 'left' && couponsList && couponsList.length"></div>
                  <!-- couponsList && couponsList.length &&  -->
                  <!-- style="width: 1731px;" -->
                  <table v-if="!loadingTableCoupon" class="product-table__table--table"  id="myTableCoupon">
                      <thead class="product-table__table--header border-0 p-0 mb-4">
                          <!-- ID -->
                          <td class="text-truncate product-table__table--header-id">
                              <span>ID</span>
                          </td>
                          <!-- Code -->
                          <td class="text-truncate product-table__table--header-domain">
                              <span>Code</span>
                          </td>
                          <!-- Type -->
                          <td class="text-truncate product-table__table--header-joined">
                              <span>Type</span>
                          </td>
                          <!-- Active -->
                          <td class="text-truncate product-table__table--header-joined">
                              <span>Active</span>
                          </td>
                          <!-- Plan ID -->
                          <td class="text-truncate product-table__table--header-id">
                              <span>Plan ID</span>
                          </td>
                          <!-- Actions -->
                          <td class="text-truncate product-table__table--header-joined">
                              <span>Actions</span>
                          </td>
                      </thead>
                      <tbody class="product-table__table--body">
                          <tr class="w-100 display-table-cell" v-if="loadingTableCoupon">
                              <s-loader :type="'scalify'" class="my-3" style="left:calc(50% - 42px);position:relative;"></s-loader>
                          </tr>
                          <tr class="w-100 display-table-cell" v-if="!loadingTableCoupon && (couponsList == null || couponsList.length == 0)">
                              <p class="my-3 position-relative font-weight-sbold" style="left:40%;">No Results</p>
                          </tr>
                          <div v-if="couponsList && couponsList.length > 0" style="max-height: 700px; overflow-y: auto; display: grid;">
                            <tr  v-show="!loadingTableCoupon" v-for="(coupon, couponIndex) in couponsList" :key="couponIndex" class="product-table__table--row w-100">
                                <!-- ID -->
                                <td  class="display-table-cell product-table__table--body-id">
                                  <p class="text-truncate">{{coupon.id}}</p>
                                </td>
                                <!-- Code -->
                                <td class="display-table-cell product-table__table--body-domain">
                                  <p  class="text-truncate display-table-cell display-inline-block">{{coupon.code}}</p>

                                  <svg v-if="coupon.status" class="display-table-cell checkmark display-inline-block ml-2" width="15" data-v-ab62a47a="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><ellipse data-v-ab62a47a="" cx="256" cy="256" rx="256" ry="255.832" style="fill: rgb(248, 0, 96);"></ellipse><g data-v-ab62a47a="" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 77.26 32)"><rect data-v-ab62a47a="" x="3.98" y="-427.615" width="55.992" height="285.672" style="fill: rgb(255, 255, 255);"></rect><rect data-v-ab62a47a="" x="-110.828" y="-312.815" width="285.672" height="55.992" style="fill: rgb(255, 255, 255);"></rect></g></svg>

                                  <svg v-else class="display-table-cell checkmark display-inline-block ml-2" width="15" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 367.805 367.805" style="enable-background:new 0 0 367.805 367.805;" xml:space="preserve">
                                    <g>
                                      <path style="fill:#3BB54A;" d="M183.903,0.001c101.566,0,183.902,82.336,183.902,183.902s-82.336,183.902-183.902,183.902
                                        S0.001,285.469,0.001,183.903l0,0C-0.288,82.625,81.579,0.29,182.856,0.001C183.205,0,183.554,0,183.903,0.001z"/>
                                      <polygon style="fill:#D4E1F4;" points="285.78,133.225 155.168,263.837 82.025,191.217 111.805,161.96 155.168,204.801
                                        256.001,103.968 	"/>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                    <g>
                                    </g>
                                  </svg>

                                </td>
                                <!-- Type -->
                                <td  class="display-table-cell product-table__table--body-joined">
                                  <p class="text-truncate">{{coupon.type}}</p>
                                </td>
                                <!-- Active -->
                                <td  class="display-table-cell product-table__table--body-joined">
                                  <s-toggle @change="changeCoupon($event, coupon, couponIndex)" v-model="coupon.status"></s-toggle>
                                </td>
                                <!-- Plan ID -->
                                <td class="display-table-cell product-table__table--body-id">
                                  <p  class="text-truncate">{{coupon.plan_id}}</p>
                                </td>
                                <!-- Actions -->
                                <td  class="display-table-cell product-table__table--body-joined">
                                  <button class="btn btn--danger btn--sm ml-2" :class="loadingButonPlansActions?'disabled':''" @click.stop="deleteCouponSelected(coupon.id, couponIndex)">Delete</button>
                                </td>
                            </tr>
                          </div>

                      </tbody>
                  </table>
                  <table v-else-if="loadingTableCoupon" class="product-table__table--table" style="width: 100%;" id="myTableCoupon">
                    <tbody class="product-table__table--body">
                      <tr class="w-100 display-table-cell">
                        <s-loader :type="'scalify'" class="my-3" style="left:calc(50% - 42px);position:relative;"></s-loader>
                      </tr>
                    </tbody>
                  </table>
                  <div class="div-shadow-right" v-if="!hideShadows && scrollIn && scrollIn !== 'right' && ((couponsList && couponsList.length))"></div>
                </div>
              </s-card-body>
              <s-card-body v-if="couponsList && couponsList.length && loadMoreCoupons && !loadingTableCoupon" class="p-0 product-table__load-more text-center">
                <button v-if="!loadingLoadMoreCoupons" class="btn btn--white" @click="loadMoreCouponCodes()">Load More</button>
                <s-loader :type="'scalify'" v-else></s-loader>
            </s-card-body>
            </s-card>
          </div>
        </div>

      </div>

      <!-- Modal -->
      <div v-if="showModal" style="background: rgba(13, 35, 62, 0.94); height: 100%; width: 100%; position: fixed; top: 0; left: 0;z-index: 13;">
        <s-card style="width: 90%; position: absolute; transform: translate(-50%,-50%); left: 50%; top: 50%;max-width: 600px;" v-clickaway="closeModale">
          <s-card-header class="font-weight-bold position-relative">
            <span>{{indexPlanToEdit == null && typeTable == 'plans'? 'New Plan' : indexPlanToEdit != null && typeTable == 'plans' ? 'Edit Plan' : typeTable == 'coupon' ? 'New Coupon' : typeTable == 'link' ? 'Link CSV' : typeTable == 'refund-coupon' ? 'Refund Coupon' : ''}}</span>
            <svg @click.stop="closeModale()" style="position: absolute; right: 20px; top: 50%; transform: translateY(-50%); cursor: pointer;" width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="3.53552" width="5" height="40" rx="2.5" transform="rotate(-45 0 3.53552)" fill="#C6D9FF"/>
              <rect x="3.53564" y="31.8198" width="5" height="40" rx="2.5" transform="rotate(-135 3.53564 31.8198)" fill="#C6D9FF"/>
            </svg>

          </s-card-header>
          <s-card-body class="p-3">
            <div v-if="typeTable == 'plans'" style="max-height: calc(100vh - 200px); overflow-y: auto;">
              <div class="mb-4">
                <p class="mb-2 font-weight-bold">Name</p>
                <s-input v-model="addPlan.name" fieldFor="settings"></s-input>
              </div>
              <div class="mb-4">
                <p class="mb-2 font-weight-bold">Interval</p>
                <s-dropdown v-model="addPlan.interval" :options="listIntervals"></s-dropdown>
              </div>
              <div class="mb-4">
                <p class="mb-2 font-weight-bold">Price</p>
                <s-input v-model="addPlan.price" fieldFor="settings"></s-input>
              </div>
              <div class="mb-4">
                <p class="mb-2 font-weight-bold">Max Adspend</p>
                <s-input v-model="addPlan.max_adspend" fieldFor="settings"></s-input>
              </div>
              <div class="mb-4">
                <p class="mb-2 font-weight-bold">Stripe Plan Id</p>
                <s-input v-model="addPlan.stripe_plan_id" fieldFor="settings"></s-input>
              </div>
              <div class="mb-4">
                <p class="mb-2 font-weight-bold">Wix Plan Id</p>
                <s-input v-model="addPlan.wix_plan_id" fieldFor="settings"></s-input>
              </div>
              <div class="mb-4">
                <p class="mb-2 font-weight-bold">Stripe Product Id</p>
                <s-input v-model="addPlan.stripe_product_id" fieldFor="settings"></s-input>
              </div>
              <div class="mb-4">
                <p class="mb-2 font-weight-bold">Paypal Plan Id</p>
                <s-input v-model="addPlan.paypal_plan_id" fieldFor="settings"></s-input>
              </div>
              <div class="mb-4">
                <p class="mb-2 font-weight-bold">Paypal Product Id</p>
                <s-input v-model="addPlan.paypal_product_id" fieldFor="settings"></s-input>
              </div>
              <div class="mb-4">
                <p class="mb-2 font-weight-bold">Plan Limits</p>
                <s-input v-model="addPlan.plan_limits" fieldFor="settings"></s-input>
              </div>
              <div class="mb-4">
                <p class="mb-2 font-weight-bold">Production</p>
                <s-toggle class="display-table-cell" v-model="addPlan.prod"></s-toggle>
              </div>
            </div>
            <button v-if="!loadingCreatePlan && typeTable == 'plans'" class="btn btn--primary w-100" :class="!addPlan.name.length || !addPlan.price.length || !addPlan.max_adspend.length ? 'disabled' : '' " @click.stop="indexPlanToEdit != null ? updatePlan() : createPlan()">{{indexPlanToEdit != null ? "Edit Plan" : "Add New Plan"}}</button>

            <button v-else-if="loadingCreatePlan && typeTable == 'plans'" class="btn btn--primary w-100 disabled"><s-loader :isWhite="true"></s-loader></button>

            <div v-if="typeTable == 'coupon'" style="max-height: calc(100vh - 200px); overflow-y: auto;">
              <div class="mb-4">
                <p class="mb-2 font-weight-bold">Count</p>
                <s-input v-model="addCoupon.count" type="number" fieldFor="settings"></s-input>
              </div>
              <div class="mb-4">
                <p class="mb-2 font-weight-bold">Enter Plan Id</p>
                <s-input v-model="addCoupon.plan" type="number" fieldFor="settings"></s-input>
              </div>
              <div class="mb-4">
                <p class="mb-2 font-weight-bold">Type</p>
                <s-input v-model="addCoupon.type" fieldFor="settings"></s-input>
              </div>
              <div class="mb-4">
                <p class="mb-2 font-weight-bold">Plan Key</p>
                <s-input v-model="addCoupon.plan_key" fieldFor="settings"></s-input>
              </div>
            </div>

            <button v-if="!loadingCreateCoupon && typeTable == 'coupon'" class="btn btn--primary w-100" :class="!addCoupon.type.length || !addCoupon.plan_key.length ||  addCoupon.count < 1 ? 'disabled' : '' " @click.stop="createCoupon()">Add New Coupons</button>

            <button v-else-if="loadingCreateCoupon && typeTable == 'coupon'" class="btn btn--primary w-100 disabled"><s-loader :isWhite="true"></s-loader></button>

            <div v-if="typeTable == 'link'">
              <p class="mb-2 font-weight-bold">Copy Link befor you close the window</p>
              <s-input v-model="csvLink" class="disabled" refe="inputlink" ref="link" fieldFor="settings"></s-input>
              <button class="btn btn--primary w-100 mt-2" @click.stop="copyLink()">Copy</button>
            </div>

            <div v-if="typeTable == 'refund-coupon'">
              <p class="mb-2 font-weight-bold">Set coupon refunded</p>
              <s-input v-model="couponRefunded" fieldFor="settings"></s-input>
              <button v-if="!loadingButtonRefundCode" :class="!couponRefunded.length?'disabled':''" class="btn btn--primary w-100 mt-2" @click.stop="refundThisCoupon()">Refund</button>
              <button v-if="loadingButtonRefundCode" class="btn btn--primary w-100 mt-2 disabled"><s-loader :isWhite="true"></s-loader></button>
            </div>

          </s-card-body>
        </s-card>
      </div>


    </div>
  </div>
</template>

<script>

export default {
  name: 'Plans',

  components:{

  },

  props: {},

  computed:{
  },

  data(){
    return{
      showColumns: false,
      hideShadows:false,
      scrollIn:"left",
      typeTable: 'plans',
      showModal: false,
      listIntervals: [
        {value: 'monthly', name: 'Monthly'},
        {value: 'yearly', name: 'Yearly'},
        {value: null, name: 'Lifetime'}
      ],

      loadingTableCoupon:false,
      addCoupon: {count:1, plan: "", type: "", plan_key : ""},
      couponsList: [],
      currentCouponsPage: 1,
      loadMoreCoupons: false,
      loadingLoadMoreCoupons: false,
      loadingCreateCoupon: false,
      loadingButonCouponsActions: false,
      indexCouponToEdit: null,
      searchCoupon: "",

      loadingTablePlan:false,
      addPlan: {name:"", interval: {value: 'monthly', name: 'Monthly'}, price: "100", max_adspend: "10000", stripe_plan_id: '', wix_plan_id: '', stripe_product_id: '', paypal_plan_id: '', paypal_product_id: '', plan_limits: '', prod: false},
      plansList: [],
      currentPlansPage: 1,
      loadMorePlans: false,
      loadingLoadMorePlans: false,
      loadingCreatePlan: false,
      loadingButonPlansActions: false,
      indexPlanToEdit: null,
      searchPlan: "",

      loadingButtonRefundCode: false,
      couponRefunded: "",

      csvLink: null

    }
  },

  methods:{
    copyLink(){
        var copyText = this.$refs.link.$refs.inputlink;
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
        this.notify('success', "Text Successfully Copied!");
    },


    async loadMoreListPlans(){
      this.loadingLoadMorePlans = true;
      try {
        let morePlans;
        if (this.searchPlan.length >= 2) {
          morePlans = await this.plansSearch(this.searchPlan, this.currentPlansPage);
        }else{
          morePlans = await this.listPlansTable(this.currentPlansPage);
        }

        if (morePlans && morePlans.data) {
          this.plansList = this.plansList.concat(morePlans.data);
          this.currentPlansPage++;
          if (morePlans && morePlans.data && morePlans.data.length >= 25) {
            this.loadMorePlans = true;
          }else{
            this.loadMorePlans = false;
          }
        }else{
          this.loadMorePlans = false;
        }
      }catch(error){
        console.log('error: ', error);
      }
      this.loadingLoadMorePlans = false;

    },
    addOrEditPlan(isEdit, plan, planIndex){

      if (isEdit) {

        this.indexPlanToEdit = planIndex;

        this.addPlan = {id: plan.id ,name:plan.name, interval: this.listIntervals.find(element => element == plan.interval), price: JSON.stringify(plan.price), max_adspend: JSON.stringify(plan.max_adspend), stripe_plan_id: plan.stripe_plan_id ? plan.stripe_plan_id : "", wix_plan_id: plan.wix_plan_id ? plan.wix_plan_id : "", stripe_product_id: plan.stripe_product_id ? plan.stripe_product_id : "", paypal_plan_id: plan.paypal_plan_id ? plan.paypal_plan_id : "", paypal_product_id: plan.paypal_product_id ? plan.paypal_product_id : "", plan_limits: plan.plan_limits ? plan.plan_limits : "", prod: plan.prod}

      }else{

        this.indexPlanToEdit = null;

      }

      this.typeTable = "plans";
      this.showModal = true

    },
    async createPlan(){
      // createNewPlan(planObject)
      this.loadingCreatePlan = true;

      try {

        let finalObject = {name: this.addPlan.name, interval: this.addPlan.interval.value, price: parseFloat(this.addPlan.price), max_adspend: parseFloat(this.addPlan.max_adspend), stripe_plan_id: this.addPlan.stripe_plan_id.length ? this.addPlan.stripe_plan_id : null, wix_plan_id: this.addPlan.wix_plan_id.length ? this.addPlan.wix_plan_id : null, stripe_product_id: this.addPlan.stripe_product_id.length ? this.addPlan.stripe_product_id : null, paypal_plan_id: this.addPlan.paypal_plan_id.length ? this.addPlan.paypal_plan_id : null, paypal_product_id: this.addPlan.paypal_product_id.length ? this.addPlan.paypal_product_id : null, plan_limits: this.addPlan.plan_limits.length ? this.addPlan.plan_limits : null, prod: this.addPlan.prod}

        const plan = await this.createNewPlan(finalObject);

        if (plan && plan.plan) {
          this.plansList.unshift(plan.plan);
          this.addPlan = {name:"", interval: {value: 'monthly', name: 'Monthly'}, price: "100", max_adspend: "10000", stripe_plan_id: '', wix_plan_id: '', stripe_product_id: '', paypal_plan_id: '', paypal_product_id: '', plan_limits: '', prod: false};
        }

      } catch (error) {
        console.log('error: ', error);
      }

      this.loadingCreatePlan = false;
      this.showModal = false
    },
    async updatePlan(){
      // createNewPlan(planObject)
      this.loadingCreatePlan = true;

      try {

        let finalObject = {name: this.addPlan.name, interval: this.addPlan.interval.value, price: parseFloat(this.addPlan.price), max_adspend: parseFloat(this.addPlan.max_adspend), stripe_plan_id: this.addPlan.stripe_plan_id.length ? this.addPlan.stripe_plan_id : null, wix_plan_id: this.addPlan.wix_plan_id.length ? this.addPlan.wix_plan_id : null, stripe_product_id: this.addPlan.stripe_product_id.length ? this.addPlan.stripe_product_id : null, paypal_plan_id: this.addPlan.paypal_plan_id.length ? this.addPlan.paypal_plan_id : null, paypal_product_id: this.addPlan.paypal_product_id.length ? this.addPlan.paypal_product_id : null, plan_limits: this.addPlan.plan_limits.length ? this.addPlan.plan_limits : null, prod: this.addPlan.prod}

        const editedPlan = await this.editPlan(finalObject, this.addPlan.id);
        console.log('editedPlan: ', editedPlan);

        if (editedPlan && editedPlan.plan) {
          this.plansList.unshift(editedPlan.plan);
        }

      } catch (error) {
        console.log('error: ', error);
      }
      this.loadingCreatePlan = false;
      this.showModal = false
    },
    async deletePlanSelected(planId, planIndex){
      this.loadingButonPlansActions = true;

      try {

        const deletePlan = await this.deletePlan(planId);
        console.log('deletePlan: ', deletePlan);

        if (deletePlan && deletePlan.message) {
          this.plansList.splice(planIndex, 1);
          this.notify('success', deletePlan.message);
        }

      } catch (error) {
        console.log('error: ', error);
      }
      this.loadingButonPlansActions = false;
    },


    async loadMoreCouponCodes(){
      this.loadingLoadMoreCoupons = true;
      try {
        let moreCouponsCode;
        if (this.searchCoupon.length >= 2) {
          moreCouponsCode = await this.couponsSearch(this.searchCoupon, this.currentCouponsPage);
        }else{
          moreCouponsCode = await this.listCouponsTable(this.currentCouponsPage);
        }

        if (moreCouponsCode && moreCouponsCode.data) {
          this.couponsList = this.couponsList.concat(moreCouponsCode.data);
          this.currentCouponsPage++;
          if (moreCouponsCode && moreCouponsCode.data && moreCouponsCode.data.length >= 25) {
            this.loadMoreCoupons = true;
          }else{
            this.loadMoreCoupons = false;
          }
        }else{
          this.loadMoreCoupons = false;
        }
      } catch (error) {
        console.log('error: ', error);
      }
      this.loadingLoadMoreCoupons = false;

    },
    addNewCoupon(){
      this.typeTable = "coupon";
      this.showModal = true
    },
    async createCoupon(){
      this.loadingCreateCoupon = true;

      try {

        let finalObject = {count: parseInt(this.addCoupon.count), plan_id: parseInt(this.addCoupon.plan), type: this.addCoupon.type, plan_key: this.addCoupon.plan_key}

        const coupon = await this.createNewCoupon(finalObject);

        if (coupon && coupon.coupons) {
          this.couponsList = this.couponsList.concat(coupon.coupons);
          this.typeTable = "link"
          this.csvLink = coupon.link;
          this.showModal = true
          this.addCoupon = {count:1, plan: "", type: "", plan_key : ""};
        }else{
          this.showModal = false
        }

      } catch (error) {
        console.log('error: ', error);
      }

      this.loadingCreateCoupon = false;
    },
    async changeCoupon(event, coupon, index){

      let data = {status: event};
      const editedCoupon = await this.editCouponStatus(data, coupon.id);
      console.log('editedCoupon: ', editedCoupon);

      if (editedCoupon && editedCoupon.coupon) {
        this.couponsList[index].status = event;
      }else{
        this.couponsList[index].status = !event;
      }

    },
    async deleteCouponSelected(couponId, planIndex){
      this.loadingButonPlansActions = true;

      try {

        const deleteCoupon = await this.deleteCoupon(couponId);
        console.log('deleteCoupon: ', deleteCoupon);

        if (deleteCoupon && deleteCoupon.message) {
          this.couponsList.splice(planIndex, 1);
          this.notify('success', deleteCoupon.message);
        }

      } catch (error) {
        console.log('error: ', error);
      }
      this.loadingButonPlansActions = false;
    },
    async refundThisCoupon(){
      this.loadingButtonRefundCode = true;

      try {

        const refundCoupon = await this.refundCouponCode(this.couponRefunded);
        console.log('refundCoupon: ', refundCoupon);

        if (refundCoupon && refundCoupon.message) {
          this.notify('success', refundCoupon.message);
        }

      } catch (error) {
        console.log('error: ', error);
      }

      this.showModal = false;
      this.loadingButtonRefundCode = false;
    },
    refundCoupon(){
      this.typeTable = "refund-coupon";
      this.showModal = true
    },


    closeModale(){
      this.addPlan = {name:"", interval: {value: 'monthly', name: 'Monthly'}, price: "100", max_adspend: "10000", stripe_plan_id: '', wix_plan_id: '', stripe_product_id: '', paypal_plan_id: '', paypal_product_id: '', plan_limits: '', prod: false};
      this.addCoupon = {count:1, plan: "", type: "", plan_key : ""};
      this.indexPlanToEdit = null;
      this.showModal = false;
    },
    getScrollPosCoupon ({ target: { scrollLeft ,clientWidth, scrollWidth }}) {
      var scroll = "left"
      if(scrollLeft == 0){
          scroll = "left"
      }
      else if(scrollLeft+clientWidth < scrollWidth){
          scroll = "middle"
      }
      if(scrollLeft+clientWidth >= scrollWidth){
          scroll = "right"
      }
      this.scrollIn = scroll
    },
    getScrollPosPlan ({ target: { scrollLeft ,clientWidth, scrollWidth }}) {
      var scroll = "left"
      if(scrollLeft == 0){
          scroll = "left"
      }
      else if(scrollLeft+clientWidth < scrollWidth){
          scroll = "middle"
      }
      if(scrollLeft+clientWidth >= scrollWidth){
          scroll = "right"
      }
      this.scrollIn = scroll
    }

  },

  watch:{

    searchPlan:{

      deep: true,
      async handler(){
        if (this.searchPlan == "") {
          this.loadingTablePlan = true;
          const plans = await this.listPlansTable(this.currentPlansPage);
          if (plans && plans.data) {
            this.plansList = plans.data;
            if (this.plansList.length >= 25) {
              this.loadMorePlans = true;
            }else{
              this.loadMorePlans = false;
            }
            this.currentPlansPage++;
          }
          this.loadingTablePlan = false;

        }else if(this.searchPlan.length >= 2){
          this.currentPlansPage = 1;
          this.loadingTablePlan = true;
          var t = 2000;

          clearTimeout(window.popTimeout);

          window.popTimeout = setTimeout(async () => {
            const resultPlanSearch = await this.plansSearch(this.searchPlan);
            console.log('resultPlanSearch: ', resultPlanSearch);
            if (resultPlanSearch && resultPlanSearch.data) {

              this.plansList = resultPlanSearch.data;
              if (this.plansList.length >= 25) {
                this.loadMorePlans = true;
              }else{
                this.loadMorePlans = false;
              }
              this.currentPlansPage++;
            }
            this.loadingTablePlan = false;
          }, t);
        }
      }

    },
    searchCoupon:{

      deep: true,
      async handler(){
        if (this.searchCoupon == "") {
          this.loadingTableCoupon = true;
          const coupons = await this.listCouponsTable(this.currentCouponsPage);
          if (coupons && coupons.data) {
            this.couponsList = coupons.data;
            if (this.couponsList.length >= 25) {
              this.loadMoreCoupons = true;
            }else{
              this.loadMoreCoupons = false;
            }
            this.currentCouponsPage++;
          }
          this.loadingTableCoupon = false;

        }else if(this.searchCoupon.length >= 2){
          this.currentCouponsPage = 1;
          this.loadingTableCoupon = true;
          var t = 2000;

          clearTimeout(window.popTimeout);

          window.popTimeout = setTimeout(async () => {
            const resultCouponSearch = await this.couponsSearch(this.searchCoupon);
            console.log('resultCouponSearch: ', resultCouponSearch);
            if (resultCouponSearch && resultCouponSearch.data) {

              this.couponsList = resultCouponSearch.data;
              if (this.couponsList.length >= 25) {
                this.loadMoreCoupons = true;
              }else{
                this.loadMoreCoupons = false;
              }
              this.currentCouponsPage++;
            }
            this.loadingTableCoupon = false;
          }, t);
        }
      }

    }

  },

  async mounted(){

    this.loadingTableCoupon = true;
    this.loadingTablePlan = true;


    // Get List Plans
    try {
      const plans = await this.listPlansTable(this.currentPlansPage);
      if (plans && plans.data) {
        this.plansList = plans.data;
        this.currentPlansPage++;

        if (plans && plans.data && plans.data.length >= 25) {
          this.loadMorePlans = true;
        }else{
          this.loadMorePlans = false;
        }
      }
    } catch (error) {
      console.log('error: ', error);
    }
    this.loadingTablePlan = false;

    // Get List Coupons
    try {
      const coupons = await this.listCouponsTable(this.currentCouponsPage);
      if (coupons && coupons.data) {
        this.couponsList = coupons.data;
        this.currentCouponsPage++;
        if (coupons && coupons.data && coupons.data.length >= 25) {
          this.loadMoreCoupons = true;
        }else{
          this.loadMoreCoupons = false;
        }
      }
    } catch (error) {
      console.log('error: ', error);
    }

    this.loadingTableCoupon = false;



  }


}
</script>

<style scoped>

</style>
